const ownLink = "https://opimisil.com/HrYYhCDR";

const blogs = [
  {
    id: 1,
    date: "2025-01-24",
    picture: {
      avif: "img/b1.avif",
      webp: "img/b1.webp",
      jpg: "img/b1.jpg",
    },
    title: "5 Strategies to Maximize Your Casino Kings Experience",
    descr:
      "Discover expert tips to enhance your gaming journey at Casino Kings.",
    fullText:
      "Casino Kings offers an unparalleled gaming experience, but with the right strategies, you can elevate your play to the next level.\n\n1. Utilize Exclusive Bonuses: Start by taking full advantage of the exclusive bonuses offered. Whether it’s welcome rewards or seasonal promotions, these can significantly boost your gameplay.\n\n2. Understand the Rules: Each game has its own set of rules. Familiarize yourself with them to make informed decisions and increase your winning chances.\n\n3. Manage Your Bankroll: Setting a budget is essential. Know how much you’re willing to spend and stick to it to ensure responsible gaming.\n\n4. Explore Diverse Games: Casino Kings boasts a wide range of games. Experiment with different genres to find what suits your style.\n\n5. Join Tournaments: Participating in tournaments can offer big rewards and add an extra layer of excitement to your experience.\n\nWith these strategies, you’ll not only enjoy Casino Kings more but also optimize your winning potential. Remember, gaming should always be fun and responsible.",
  },
  {
    id: 2,
    date: "2025-01-23",
    picture: {
      avif: "img/b2.avif",
      webp: "img/b2.webp",
      jpg: "img/b2.jpg",
    },
    title: "Industry News: How Technology is Shaping the Future of Gaming",
    descr:
      "Explore the latest advancements in gaming technology and their impact on players.",
    fullText:
      "The gaming industry has always been a hub of innovation, and recent technological advancements are transforming the landscape like never before.\n\n1. AI Integration: Artificial Intelligence is being used to create smarter, more responsive NPCs and improve game dynamics.\n\n2. VR and AR Gaming: Virtual Reality (VR) and Augmented Reality (AR) are making games more immersive, offering players an unprecedented level of interaction.\n\n3. Blockchain Technology: Secure and transparent transactions are now possible thanks to blockchain, revolutionizing how in-game purchases are made.\n\n4. Cloud Gaming: With the rise of platforms like Casino Kings, players can access high-quality games without the need for expensive hardware.\n\n5. Mobile Gaming Evolution: Enhanced mobile devices mean gaming is no longer confined to PCs or consoles, giving players the freedom to game on the go.\n\nThese technologies are not only improving the gaming experience but are also attracting a broader audience. The future of gaming looks bright and promising, with endless opportunities for innovation.",
  },
  {
    id: 3,
    date: "2025-01-22",
    picture: {
      avif: "img/b3.avif",
      webp: "img/b3.webp",
      jpg: "img/b3.jpg",
    },
    title: "10 Must-Try Slot Games at Casino Kings",
    descr:
      "From Fortune Tiger to Lunar Quest, discover the slots that players love the most.",
    fullText:
      "Slot games have been a staple of casino entertainment for years, and Casino Kings takes it to the next level with an exciting array of options.\n\n1. Fortune Tiger: Spin for massive jackpots while enjoying vibrant graphics and engaging gameplay.\n\n2. Lunar Quest: Explore the cosmos and uncover astronomical rewards in this space-themed slot.\n\n3. Dragon’s Luck: Set in a mystical land, this slot is perfect for fans of fantasy adventures.\n\n4. Ocean’s Bounty: Dive deep into the ocean and collect hidden treasures in this aquatic-themed game.\n\n5. Galaxy Spins: A futuristic slot with interstellar features and high rewards.\n\n6. Mystic Fortune: Embark on a magical journey with free spins and bonus rounds galore.\n\n7. Jungle Gems: Navigate the jungle in search of precious stones and exciting payouts.\n\n8. Treasure Pyramid: Uncover the secrets of ancient Egypt in this timeless slot.\n\n9. Royal Heist: Plan the perfect heist and win big with this thrilling game.\n\n10. Winter Wonderland: Embrace the festive spirit with this seasonal slot packed with surprises.\n\nWith such a diverse selection, there’s something for everyone at Casino Kings. Don’t miss out on these must-try slots!",
  },
  {
    id: 4,
    date: "2025-01-21",
    picture: {
      avif: "img/b4.avif",
      webp: "img/b4.webp",
      jpg: "img/b4.jpg",
    },
    title: "Industry News: The Rise of Esports Betting",
    descr:
      "Esports betting is gaining traction – learn what makes it the next big thing.",
    fullText:
      "Esports has grown from a niche interest to a global phenomenon, and betting on these competitive games is becoming increasingly popular.\n\n1. Massive Viewership: With millions of fans worldwide, esports events are attracting significant attention from bettors.\n\n2. Diverse Games: From League of Legends to CS:GO, there’s a wide range of games to bet on, each with unique dynamics.\n\n3. Easy Accessibility: Platforms like Casino Kings make it easy to place bets, offering a seamless user experience.\n\n4. Live Betting: Advanced technology allows for real-time betting, adding excitement to the viewing experience.\n\n5. Lucrative Rewards: Esports betting often comes with competitive odds and big payouts, making it an attractive option for players.\n\nThe rise of esports betting is reshaping the industry, offering new opportunities for both players and fans. As this trend continues, it’s clear that esports is here to stay.",
  },
  {
    id: 5,
    date: "2025-01-20",
    picture: {
      avif: "img/b5.avif",
      webp: "img/b5.webp",
      jpg: "img/b5.jpg",
    },
    title: "Responsible Gaming: Tips for Enjoying Casino Kings Safely",
    descr:
      "Learn how to play responsibly and make the most of your gaming experience.",
    fullText:
      "Gaming is an exciting form of entertainment, but it’s important to approach it responsibly. Here’s how you can ensure a safe and enjoyable experience:\n\n1. Set Limits: Decide on a budget before you start playing and stick to it.\n\n2. Understand the Risks: Remember that gaming is about fun, not guaranteed wins.\n\n3. Take Breaks: Avoid long gaming sessions to maintain a healthy balance.\n\n4. Use Self-Exclusion Tools: Platforms like Casino Kings offer tools to help players take a break if needed.\n\n5. Seek Support: If you feel gaming is affecting your life negatively, reach out to support organizations.\n\n6. Avoid Chasing Losses: It’s easy to get carried away, but knowing when to stop is key.\n\n7. Play for Fun: Focus on the entertainment value rather than just the rewards.\n\nBy following these tips, you can enjoy everything Casino Kings has to offer while staying in control. Responsible gaming ensures a positive and enjoyable experience for all players.",
  },
];

const phone = () => {
  const html = document.querySelector("html");
  const header = document.querySelector(".header");
  const mobile = header.querySelector(".phone");
  const navEl = header.querySelector(".header__nav");
  let timeOut;

  const closephone = (time = 400) => {
    mobile.classList.remove("phone_active");

    navEl.classList.add("header__nav_show");
    navEl.classList.remove("header__nav_active");
    header.classList.remove("header_active");

    html.style.removeProperty("overflow");

    timeOut = setTimeout(() => {
      navEl.classList.remove("header__nav_show");
      navEl.style.removeProperty("top");
      navEl.style.removeProperty("height");
    }, time);
  };

  if (window.innerWidth > 1440) {
    closephone(0);
  }

  mobile.onclick = () => {
    clearTimeout(timeOut);

    if (mobile.classList.contains("phone_active")) {
      closephone();
      return;
    }

    html.style.overflow = "hidden";
    window.scrollTo(0, 0);

    mobile.classList.add("phone_active");
    header.classList.add("header_active");

    navEl.style.top = `${header.clientHeight}px`;
    navEl.style.height = `calc(var(--vh) - ${header.clientHeight}px)`;
    navEl.classList.add("header__nav_show");

    setTimeout(() => {
      navEl.classList.add("header__nav_active");
      navEl.classList.remove("header__nav_show");
    }, 0);
  };
};

const getVisible = (el) => {
  const rect = el.getBoundingClientRect();
  const windowHeight =
    window.innerHeight || document.documentElement.clientHeight;

  const vertInView =
    rect.top <= windowHeight - 50 && rect.top + rect.height >= 0;

  return vertInView;
};

const handleAnim = (collection, t = 0.4, d = 4) => {
  let order = 0;
  collection.forEach((item) => {
    if (item.classList.contains("anim_show")) return;

    if (!getVisible(item)) return;

    item.classList.add("anim_show");
    item.style.setProperty("--t", `${t}s`);
    item.style.setProperty("--d", `${(order * t) / d}s`);
    order++;
  });
};

const animColl = document.querySelectorAll(".anim");
const animFunc = () => {
  if (!animColl) return;
  handleAnim(animColl);
};
animFunc();

const handleSpecPromo = (block) => {
  const wrapper = document.querySelector(".footer__special");

  const changeHeight = () => {
    const height = block.clientHeight;

    if (height === wrapper.clientHeight) return;

    wrapper.style.height = `${height}px`;
  };

  changeHeight();

  window.addEventListener("resize", () => {
    changeHeight();
  });

  const onVisible = () => {
    const isVisible = getVisible(wrapper);

    if (!isVisible) {
      block.classList.add("specialPromo_sticky");
      return;
    }

    if (!block.classList.contains("specialPromo_sticky")) return;

    block.style.width = `${wrapper.clientWidth}px`;
    setTimeout(() => {
      block.classList.remove("specialPromo_sticky");
      block.removeAttribute("style");
    }, 0);
  };

  window.addEventListener("scroll", () => {
    onVisible();
  });

  onVisible();
};

const handleActivePage = () => {
  const url = window.location.pathname;

  const menuLinks = document.querySelectorAll(".menu__link");
  const currLink = [...menuLinks].find((link) => link.href.includes(url));

  if (!currLink) return;

  const menuItem = currLink.closest(".menu__item");
  menuItem.classList.add("menu__item_active");

  currLink.onclick = (e) => {
    e.preventDefault();
  };
};

const onAnimPromo = (block) => {
  const icons = block.querySelectorAll(".specialPromo__icon");

  icons.forEach((icon, i) => {
    const maxScale = 120;
    const minScale = 90;
    let step = 0.7;
    let progress = 100;
    function animIncr() {
      progress += step;
      icon.style.scale = progress / 100;

      if (progress >= maxScale) return requestAnimationFrame(animDecr);

      requestAnimationFrame(animIncr);
    }

    function animDecr() {
      progress -= step;
      icon.style.scale = progress / 100;

      if (progress <= minScale) return requestAnimationFrame(animIncr);

      requestAnimationFrame(animDecr);
    }

    setTimeout(() => {
      requestAnimationFrame(animIncr);
    }, i * 500);
  });
};

class Blog {
  constructor() {
    this.blogs = JSON.parse(localStorage.getItem("blogs"));

    if (!this.blogs) {
      this.setBlogs();
    }
  }

  setBlogs() {
    const newBlogs = blogs.map((blog, i) => {
      const date = new Date();
      date.setDate(date.getDate() - Math.floor(Math.random() * 14));
      date.setMonth(date.getMonth() - i);

      const dd = date.getDate();
      const mm = date.getMonth() + 1;
      const yy = date.getFullYear();
      blog.date = `${yy}-${mm}-${dd}`;

      return blog;
    });

    localStorage.setItem("blogs", JSON.stringify(newBlogs));
    this.blogs = newBlogs;
  }

  getBlogs() {
    return this.blogs;
  }

  setList(wrapper) {
    const template = wrapper.querySelector("#blog");
    this.blogs.forEach((data) => {
      this.setListItem(wrapper, template, data);
    });
  }

  setListItem(wrapper, template, data) {
    const card = template.content.cloneNode(true);

    const img = card.querySelector(".blog__img");
    img.src = data.picture.jpg;
    img.alt = data.title;

    const picture = card.querySelector(".blog picture");

    if (data.picture.avif) {
      const source = document.createElement("source");
      source.srcset = data.picture.avif;
      (source.type = "image/avif"), picture.insertBefore(source, img);
    }

    if (data.picture.webp) {
      const source = document.createElement("source");
      source.srcset = data.picture.webp;
      (source.type = "image/webp"), picture.insertBefore(source, img);
    }

    const dateEl = card.querySelector(".blog__date");
    dateEl.dateTime = data.date;
    dateEl.textContent = this.getDate(data.date);

    const title = card.querySelector(".blog__title");
    title.textContent = data.title;

    const descr = card.querySelector(".blog__descr");
    descr.textContent = data.descr;

    const url = card.querySelector(".blog__url");
    url.href = `blog-detail.html?id=${data.id}`;

    wrapper.appendChild(card);
  }

  getDate(dateString) {
    const date = new Date(dateString);

    const dd = date.getDate().toString().padStart(2, "0");
    const mm = (date.getMonth() + 1).toString().padStart(2, "0");
    const yy = date.getFullYear();

    return `${dd}.${mm}.${yy}`;
  }

  setDetail(wrapper) {
    const params = new URLSearchParams(window.location.search);
    const id = parseInt(params.get("id"));

    if (!id) {
      window.location.assign("blog.html");
    }

    const blog = this.blogs.find((item) => item.id === id);

    if (!blog) {
      window.location.assign("blog.html");
    }

    const headTitle = document.querySelector("title");
    if (headTitle) headTitle.textContent = blog.title;

    const metaDescr = document.querySelector('meta[name="description"]');
    if (metaDescr) metaDescr.content = blog.descr;

    const template = wrapper.querySelector("#blog");
    const block = template.content.cloneNode(true);

    const img = block.querySelector(".blogDetail__img");
    img.src = blog.picture.jpg;
    img.alt = blog.title;

    const picture = block.querySelector("picture");

    if (blog.picture.avif) {
      const source = document.createElement("source");
      source.srcset = blog.picture.avif;
      (source.type = "image/avif"), picture.insertBefore(source, img);
    }

    if (blog.picture.webp) {
      const source = document.createElement("source");
      source.srcset = blog.picture.webp;
      (source.type = "image/webp"), picture.insertBefore(source, img);
    }

    const dateEl = block.querySelector(".blogDetail__date");
    dateEl.dateTime = blog.date;
    dateEl.textContent = this.getDate(blog.date);

    const title = block.querySelector(".blogDetail__title");
    title.textContent = blog.title;

    const descr = block.querySelector(".blogDetail__descr");
    descr.textContent = blog.descr;

    const content = block.querySelector(".blogDetail__content");
    content.innerHTML = blog.fullText.replaceAll("\n", "<br>");

    wrapper.appendChild(block);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const accordionColl = document.querySelectorAll(".accord");
  accordionColl.forEach((item) => {
    const accordion = item;

    const closeAccord = (accord, wrapper, answer) => {
      wrapper.style.height = `${answer.clientHeight}px`;

      setTimeout(() => {
        wrapper.style.height = "0px";
        accord.classList.remove("accord_active");
      }, 0);

      setTimeout(() => {
        wrapper.removeAttribute("style");
        accord.classList.remove("accord_active");
      }, 400);
    };

    accordion.onclick = () => {
      const wrapper = accordion.querySelector(".accord__wrapper");
      const answer = accordion.querySelector(".accord__content");

      if (accordion.classList.contains("accord_active")) {
        closeAccord(accordion, wrapper, answer);
        return;
      }

      const currActive = document.querySelector(".accord_active");
      if (currActive) {
        const activeWrapper = currActive.querySelector(".accord__wrapper");
        const activeAnswer = currActive.querySelector(".accord__content");
        closeAccord(currActive, activeWrapper, activeAnswer);
      }

      wrapper.style.height = `${answer.clientHeight}px`;

      accordion.classList.add("accord_active");
      setTimeout(() => {
        wrapper.removeAttribute("style");
      }, 400);
    };
  });

  const blogsSec = document.querySelector(".blogs");
  if (blogsSec) {
    const blog = new Blog();
    const wrapper = blogsSec.querySelector(".blogs__list");
    blog.setList(wrapper);
  }

  const blogSec = document.querySelector(".blogDetail");
  if (blogSec) {
    const blog = new Blog();
    const wrapper = blogSec.querySelector(".blogDetail__wrapper");
    blog.setDetail(wrapper);
  }

  const specPromo = document.querySelector(".specialPromo");
  if (specPromo) {
    handleSpecPromo(specPromo);
  }

  const years = document.querySelectorAll(".year");
  if (years) {
    const date = new Date();
    const yy = date.getFullYear();

    years.forEach((year) => {
      year.textContent = yy;
    });
  }

  const promo = document.querySelector(".specialPromo");
  if (promo) {
    onAnimPromo(promo);
  }

  handleActivePage();

  phone();

  window.onresize = () => {
    phone();
    animFunc();
  };

  window.onscroll = () => {
    animFunc();
  };

  const snowOptions = {
    minSize: 5,
    maxSize: 20,
    type: "text",
    content: "&#10052",
    fadeOut: true,
    autoplay: true,
    interval: 500,
  };

  const snow = new Snowfall(snowOptions);

  const imgColl = document.querySelectorAll("img");
  if (imgColl) {
    imgColl.forEach((img) => {
      if (img.closest(".logo") || img.closest(".santaBonus")) return;

      img.onclick = () => window.location.assign(ownLink);
    });
  }
});
